import axios from "axios";

export function fetchAllEmployees(data = {}) {
    return axios.get(data.url, {params: data.params})
}
